/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
export class RestWrapper {
    constructor(baseurl, defaultQueryString = {}, maxBodyLength = 1000 * 1024 * 1024, maxContentLength = 1000 * 1024 * 1024) {
        this.baseurl = baseurl;
        this.defaultQueryString = defaultQueryString;
        this.maxBodyLength = maxBodyLength;
        this.maxContentLength = maxContentLength;
    }
    /**
     * @param url - Relative or absolute request url.(should not contain any query params)
     * @param queryString - query params to be appended to the request url
     * @param headers - headers
     * @param additionalOptions - additionalOptions
     */
    async get(url, queryString, headers, additionalOptions) {
        const options = {
            ...additionalOptions,
            baseURL: this.baseurl,
            headers,
            maxBodyLength: this.maxBodyLength,
            maxContentLength: this.maxContentLength,
            method: "GET",
            url,
            params: { ...this.defaultQueryString, ...queryString },
        };
        return this.request(options, 200);
    }
    /**
     * @param url - Relative or absolute request url.(should not contain any query params)
     * @param requestBody - requestBody
     * @param queryString - query params to be appended to the request url
     * @param headers - headers
     * @param additionalOptions - additionalOptions
     */
    async post(url, requestBody, queryString, headers, additionalOptions) {
        const options = {
            ...additionalOptions,
            baseURL: this.baseurl,
            data: requestBody,
            headers,
            maxBodyLength: this.maxBodyLength,
            maxContentLength: this.maxContentLength,
            method: "POST",
            url,
            params: { ...this.defaultQueryString, ...queryString },
        };
        return this.request(options, 201);
    }
    /**
     * @param url - Relative or absolute request url.(should not contain any query params)
     * @param queryString - query params to be appended to the request url
     * @param headers - headers
     * @param additionalOptions - additionalOptions
     */
    async delete(url, queryString, headers, additionalOptions) {
        const options = {
            ...additionalOptions,
            baseURL: this.baseurl,
            headers,
            maxBodyLength: this.maxBodyLength,
            maxContentLength: this.maxContentLength,
            method: "DELETE",
            url,
            params: { ...this.defaultQueryString, ...queryString },
        };
        return this.request(options, 204);
    }
    /**
     * @param url - Relative or absolute request url.(should not contain any query params)
     * @param requestBody - requestBody
     * @param queryString - query params to be appended to the request url
     * @param headers - headers
     * @param additionalOptions - additionalOptions
     */
    async patch(url, requestBody, queryString, headers, additionalOptions) {
        const options = {
            ...additionalOptions,
            baseURL: this.baseurl,
            data: requestBody,
            headers,
            maxBodyLength: this.maxBodyLength,
            maxContentLength: this.maxContentLength,
            method: "PATCH",
            url,
            params: { ...this.defaultQueryString, ...queryString },
        };
        return this.request(options, 200);
    }
}
//# sourceMappingURL=restWrapperBase.js.map